import './app/style.scss';

import './node_modules/@synisys/idm-ng-controls/lib/kendo/styles/kendo.common-material.min.css';
import './node_modules/@synisys/idm-ng-controls/lib/kendo/styles/kendo.material.min.css';
import './node_modules/@synisys/idm-ng-controls/lib/kendo/styles/kendo.rtl.min.css';
// import './node_modules/@synisys/idm-dynamic-forms-ui/idm-dynamic-forms-ui.css';
import * as Hammer from 'hammerjs';
window.Hammer = Hammer;
